const NATIONALITIES = [
'afgano',
'alemán',
'árabe',
'argentino',
'australiano',
'belga',
'boliviano',
'brasileño',
'camboyano',
'canadiense',
'chileno',
'chino',
'colombiano',
'coreano',
'costarricense',
'cubano',
'danés',
'ecuatoriano',
'egipcio',
'salvadoreño',
'escocés',
'español',
'estadounidense',
'estonio',
'etiope',
'filipino',
'finlandés',
'francés',
'galés',
'griego',
'guatemalteco',
'haitiano',
'holandés',
'hondureño',
'indonés',
'inglés',
'iraquí',
'iraní',
'irlandés',
'israelí',
'italiano',
'japonés',
'jordano',
'laosiano',
'letón',
'letonés',
'malayo',
'marroquí',
'mexicano',
'nicaragüense',
'noruego',
'neozelandés',
'panameño',
'paraguayo',
'peruano',
'polaco',
'portugués',
'puertorriqueño',
'dominicano',
'rumano',
'ruso',
'sueco',
'suizo',
'tailandés',
'taiwanes',
'turco',
'ucraniano',
'uruguayo',
'venezolano',
'vietnamita',
]

export default NATIONALITIES;


/** WEBPACK FOOTER **
 ** ./src/libs/es-nationalities.js
 **/